<template>
  <span class="ui label date-picker">
    <picker
      class="picker selection compact"
      :items="hours"
      placeholder="10"
      display-property="label"
      key-property="value"
    />
    <picker
      class="picker selection compact"
      :items="minutes"
      placeholder="00"
      display-property="label"
      key-property="value"
    />
    <picker
      class="picker selection compact"
      :items="amPm"
      placeholder="AM"
      display-property="label"
      key-property="value"
    />
  </span>
</template>

<script>
import Picker from './Picker'
import moment from 'moment'

export default {
  name: 'DatePicker',
  components: { Picker },
  computed: {
    now: function () {
      var now = moment()

      const components = {
        hours: now.format().hours(),
        minutes: now.format().minutes(),
      }

      return components
    },
    hours: function () {
      // Use spread operator and ES2015: https://stackoverflow.com/a/36953272/224988
      const ints = [...Array(13).keys()].slice(1)
      return this.optionsFromInts(ints)
    },
    minutes: function () {
      const ints = [...Array(59).keys()]
      return this.optionsFromInts(ints)
    },
    amPm: function () {
      return [{
        label: 'AM',
        value: 'am',
      },
      {
        label: 'PM',
        value: 'am',
      }]
    },
  },
  methods: {
    optionsFromInts: function (ints) {
      return ints.map(number => {
        const isSingleDigit = number < 10
        const padding = isSingleDigit ? '0' : ''
        return {
          label: padding + number.toString(10),
          value: number,
        }
      })
    },
  },
}
</script>

<style scoped>
.label {
  margin: 0 !important;
  padding: 4px 2px !important;
}

.picker {
  z-index: 999;
  margin: 0 !important;
}
</style>
